import { render } from "./UserAktif.vue?vue&type=template&id=56faa7f8"
import script from "./UserAktif.vue?vue&type=script&lang=js"
export * from "./UserAktif.vue?vue&type=script&lang=js"

import "./UserAktif.vue?vue&type=style&index=0&id=56faa7f8&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__